import React from 'react';
import { Tool } from './Tool';

export class TextTool extends Tool {
	constructor({ store }) {
		super({
			mode: 'text',
			name: '文本工具',
			className: 'text',
			cursor: 'text',
			store,
		});
	}

	onActived() {
		this.store.setState({ text: null });
	}

	onInput({ type, x, y, e }) {
		const { getState, setState } = this.store;

		if (type == 'mousedown') {
			const last = this.commit();
			setState({
				placed: true,
				x, y,
				text: null,
				dragging: true,
			});
			this.focus();
			this.clear();
			return { commit: !!last, drawing: last };
		}
		if (type == 'mousemove') {
			const { dragging } = getState();
			if (dragging) {
				setState({ x, y });
			}
			return { commit: false, drawing: null };
		}
		if (type == 'mouseup') {
			setState({ dragging: false });
			return { commit: false, drawing: null };
		}
		if (type == 'keydown' && e.keyCode == 13) {
			setState({ placed: false });
			e.preventDefault();
			const drawing = this.commit();
			return { commit: !!drawing, drawing };
		}
		return { commit: false, drawing: null };
	}

	onDeactived() {
		const drawing = this.commit();
		this.store.setState({ actived: false, placed: false });
		return { commit: !!drawing, drawing };
	}

	commit() {
		const { getState, setState } = this.store;
		const { x, y, text } = getState();
		if (!text || !/\S/.test(text)) {
			return null
		}
		return { type: this.mode, param: [x, y, text] };
	}

	onRenderCanvas(ctx, drawing) {
		const { commited, type, param, brushColor, fontFamily, fontSize } = drawing;

		// 没有提交的文本，交给 React 组件渲染
		if (!commited) return;

		const [x, y, text] = param;
		ctx.save();
		ctx.fillStyle = brushColor;
		ctx.textBaseline = 'top';
		ctx.font = `${fontSize}px '${fontFamily}'`;
		ctx.fillText(text, x + 6, y - fontSize / 2 + 2);
		ctx.restore();
	}

	onRenderElement(styles) {
		const { getState, setState } = this.store;
		const { brushColor, fontFamily, fontSize } = styles;

		const { x, y, dragging, placed } = getState();

		if (!placed) return null;

		const updateText = (e) => setState({
			text: e.target.textContent,
		});

		const style = {
			position: 'absolute',
			left: 0,
			top: 0,
			transform: `translate3d(${x}px, ${y - fontSize / 2}px, 0)`,
			border: '1px dashed black',
			padding: '0 5px',
			fontFamily: fontFamily,
			fontSize: fontSize + 'px',
			color: brushColor,
			minWidth: 50,
			minHeight: fontSize * 1.5,
			textAlign: 'left',
			pointerEvents: dragging ? 'none' : 'all',
		};

		return (
			<div
				key={this.mode}
				ref={element => this.inputElement = element}
				className="image-overlay-text-input"
				contentEditable
				onKeyUp={updateText} // IE 不支持 onInput
				onInput={updateText}
				style={style}>
			</div>
		);
	}

	focus() {
		setTimeout(() => {
			if (this.inputElement) {
				this.inputElement.focus();
			}
		}, 10);
	}

	clear() {
		if (this.inputElement) {
			this.inputElement.textContent = '';
		}
	}
}


// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/tools/TextTool.js